/**
 * Party
 * iMIS Party API
 *
 * OpenAPI spec version: 20.3.44
 * Contact: support@advsol.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


/**
 * Property of a generic entity. An instance of a single property.
 */
export class GenericPropertyData { 
    /**
     * The DataType must be \"Asi.Soa.Core.DataContracts.GenericPropertyData, Asi.Contracts\"
     */
    $type = 'Asi.Soa.Core.DataContracts.GenericPropertyData, Asi.Contracts';
    /**
     * Gets or sets the name.
     */
    Name?: string;
    /**
     * Gets or sets the value.
     */
    Value?: any;
}
